module.exports = __webpack_public_path__ + "static/img/1.f81056d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/zh/1.png
// module id = uxee
// module chunks = 0